// extracted by mini-css-extract-plugin
export var main = "input-module--main--34bf3";